module.exports = __webpack_public_path__ + "static/media/study211209.223fa12f.png";